import {
    FETCH_WORKOUTS,
    FETCH_PROVIDER_WORKOUTS,
    UPDATE_WORKOUTS_FILTER,
    RESET_WORKOUTS_FILTER,
    UPDATE_FILTERED_WORKOUTS,
    FETCH_WHEELCHAIR_WORKOUTS
} from './ActionTypes';

// Note: there are other query params available for this endpoint that allow for filtering
// > docs: http://connectapi.garmin.com/workout-service/document/endpoint.html
export function fetchWorkouts(start, limit, myWorkoutsOnly, sharedWorkoutsOnly, workoutProvider) {
    return {
        type: FETCH_WORKOUTS,
        payload: { start, limit, myWorkoutsOnly, sharedWorkoutsOnly, workoutProvider }
    };
}

export function fetchProviderWorkouts(locale, viewerSocialProfile) {
    return {
        type: FETCH_PROVIDER_WORKOUTS,
        payload: { locale, viewerSocialProfile }
    };
}

export function fetchWheelchairWorkouts(locale, viewerSocialProfile, isWheelchairModeEnabled) {
    return {
        type: FETCH_WHEELCHAIR_WORKOUTS,
        payload: { locale, viewerSocialProfile, isWheelchairModeEnabled }
    };
}

export function updateWorkoutsFilter(enabledFilters, isWheelchairModeEnabled) {
    return {
        type: UPDATE_WORKOUTS_FILTER,
        enabledFilters,
        isWheelchairModeEnabled
    };
}

export function resetWorkoutsFilter(isWheelchairModeEnabled) {
    return {
        type: RESET_WORKOUTS_FILTER,
        isWheelchairModeEnabled
    };
}

export function updateFilteredWorkouts(filteredWorkouts) {
    return {
        type: UPDATE_FILTERED_WORKOUTS,
        filteredWorkouts
    };
}
